import React, { useState, useEffect, useContext, useRef } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import Points from "../Inventory/Points";
import Pixels from "../Inventory/Pixels";
import CompanyInfo from "./CompanyInfo";
import ComplaintsMessages from "./ComplaintsMessages";
import { VendersContext } from "../../context/Store";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import Select from "react-select";
import { Image } from "primereact/image";
import { FileUpload } from "primereact/fileupload";

const SettingForm = () => {
  let { isLang, setIsLang } = useContext(VendersContext);
  const [loading, setLoading] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem("langChange") || "en");

  const toast = useRef(null);

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    image: "",
    phone: "",
    old_password: "",
    new_password: ""
  });

  const [notificationData, setNotificationData] = useState({
    title: "",
    body: "",
    title_en: "",
    title_de: "",
    title_ar: "",
    body_en: "",
    body_de: "",
    body_ar: "",
    url: "",
    picture: null
  });

  const handleNotificationChange = e => {
    const { name, value } = e.target;
    setNotificationData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleNotificationSend = async e => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("title_en", notificationData.title_en);
    formData.append("title_de", notificationData.title_de);
    formData.append("title_ar", notificationData.title_ar);
    formData.append("body_en", notificationData.body_en);
    formData.append("body_de", notificationData.body_de);
    formData.append("body_ar", notificationData.body_ar);
    formData.append("url", notificationData.url);
    formData.append("product_code", selectedProductCode);

    if (notificationData.picture) {
      formData.append("picture", notificationData.picture);
    }

    try {
      const response = await fetch("https://api.insekten-scanner.com/api/dashboard/notifications/push_noitification", {
        method: "POST",
        headers: {
          token: localStorage.getItem("userToken")
        },
        body: formData
      });

      if (response.ok) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Notification sent successfully!",
          life: 3000
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to send notification",
          life: 3000
        });
      }
    } catch (error) {
      console.error("Error sending notification:", error);
    }
  };
  const handlePictureChange = e => {
    const file = e.target.files[0];
    setNotificationData(prevData => ({
      ...prevData,
      picture: file
    }));
  };
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [selectedProductCode, setSelectedProductCode] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(
    () => {
      if (inputValue.trim() !== "") {
        searchProduct(inputValue);
      } else {
        setProducts([]);
      }
    },
    [inputValue, selectedLanguage]
  );
  const searchProduct = async inputValue => {
    try {
      const response = await axios.get(
        `https://api.insekten-scanner.com/api/dashboard/notifications/products_search/${inputValue}`,
        {
          headers: {
            token: localStorage.getItem("userToken"),
            lang: selectedLanguage
          }
        }
      );

      const filteredProducts = response.data.data.products.map(product => ({
        value: product.id,
        label: `${product.name} (${product.code})`,
        code: product.code
      }));

      setProducts(filteredProducts);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const onProductSelect = selectedOption => {
    setSelectedProduct(selectedOption);
    setSelectedProductCode(selectedOption ? selectedOption.code : "");
  };

  useEffect(() => {
    searchProduct();
  }, []);
  return (
    <>
      <Toast ref={toast} />
      <TabView className="card rounded-4 p-4">
        <TabPanel header={isLang === "en" ? "Company Information" : "بيانات الشركة"}>
          <div>
            <CompanyInfo />
          </div>
        </TabPanel>

        <TabPanel header={isLang === "en" ? "Notifications" : " الاشعارات"}>
          <form onSubmit={handleNotificationSend}>
            <TabView>
              <TabPanel header={isLang === "en" ? "English" : "اللغة الانجليزية"} forceRender={true}>
                <div>
                  <label htmlFor="title_en" className="h6 mt-3">
                    {isLang === "en" ? "Title EN" : "الاسم"}
                  </label>
                  <input
                    className="form-control form-control-lg"
                    type="text"
                    id="title_en"
                    name="title_en"
                    value={notificationData.title_en}
                    onChange={handleNotificationChange}
                  />
                </div>
                <div>
                  <label htmlFor="body_en" className="h6 mt-3">
                    {isLang === "en" ? "Body EN" : "محتوى الرسالة"}
                  </label>
                  <textarea
                    className="form-control form-control-lg mb-3"
                    id="body_en"
                    name="body_en"
                    value={notificationData.body_en}
                    onChange={handleNotificationChange}
                  />
                </div>
              </TabPanel>
              <TabPanel header={isLang === "en" ? "Germany" : "اللغة الالمانية"} forceRender={true}>
                <div>
                  <label htmlFor="title_de" className="h6 mt-3">
                    {isLang === "en" ? "Title DE" : "الاسم"}
                  </label>
                  <input
                    className="form-control form-control-lg"
                    type="text"
                    id="title_de"
                    name="title_de"
                    value={notificationData.title_de}
                    onChange={handleNotificationChange}
                  />
                </div>

                <div>
                  <label htmlFor="body_de" className="h6 mt-3">
                    {isLang === "en" ? "Body DE" : "محتوى الرسالة"}
                  </label>
                  <textarea
                    className="form-control form-control-lg mb-3"
                    id="body_de"
                    name="body_de"
                    value={notificationData.body_de}
                    onChange={handleNotificationChange}
                  />
                </div>
              </TabPanel>
              <TabPanel header={isLang === "en" ? "Arabic" : "اللغة العربية"}>
                <div>
                  <label htmlFor="title_ar" className="h6 mt-3">
                    {isLang === "en" ? "Title AR" : "الاسم"}
                  </label>
                  <input
                    className="form-control form-control-lg"
                    type="text"
                    id="title_ar"
                    name="title_ar"
                    value={notificationData.title_ar}
                    onChange={handleNotificationChange}
                  />
                </div>
                <div>
                  <label htmlFor="body_ar" className="h6 mt-3">
                    {isLang === "en" ? "Body AR" : "محتوى الرسالة"}
                  </label>
                  <textarea
                    className="form-control form-control-lg mb-3"
                    id="body_ar"
                    name="body_ar"
                    value={notificationData.body_ar}
                    onChange={handleNotificationChange}
                  />
                </div>
              </TabPanel>
            </TabView>

            {/* add product */}
            <div className="mb-3 px-3">
              <label className="h6 mt-3 info-label" htmlFor="productSelect">
                Select Product
              </label>
              <Select
                id="productSelect"
                value={selectedProduct}
                onChange={onProductSelect}
                options={products}
                onInputChange={value => setInputValue(value)}
                placeholder="Search and select a product"
                isClearable
              />
            </div>

            <div className="mb-3 px-3">
              <label className="h6 mt-3 info-label" htmlFor="url">
                {isLang === "en" ? "Redirect URL" : "رابط اعادة التوجيه"}
              </label>
              <textarea
                className="form-control"
                id="url"
                name="url"
                value={notificationData.url}
                onChange={handleNotificationChange}
              />
              <div className="d-flex flex-row justify-content-between mt-3">
                <label className="h6 mt-3 info-label" htmlFor="imgUrl">
                  {isLang === "en" ? " Add Image " : "اضافة صورة"}
                  <input className="form-control" type="file" onChange={handlePictureChange} />
                </label>
                {notificationData.picture && (
                  <div>
                    <Image src={URL.createObjectURL(notificationData.picture)} width="90px" height="100px" preview />
                  </div>
                )}
              </div>
            </div>

            <button type="submit" className="btn btn-primary mx-3" disabled={loading}>
              {loading ? "Sending..." : "Send Notification"}
            </button>
          </form>
        </TabPanel>

        <TabPanel header={isLang === "en" ? "Points" : " النقاط"}>
          <Points />
        </TabPanel>
        <TabPanel header={isLang === "en" ? "Pixels" : " الاعلانات"}>
          <Pixels />
        </TabPanel>
        <TabPanel header={isLang === "en" ? "Complaints" : " الشكاوى"}>
          <ComplaintsMessages />
        </TabPanel>
        <TabPanel header={isLang === "en" ? "Payment" : " الدفع"}> </TabPanel>
        <TabPanel header={isLang === "en" ? "Subscriptions" : " الاشتراكات"}> </TabPanel>
      </TabView>
    </>
  );
};

export default SettingForm;
